export enum MimeType {
	ZIP = 'application/zip'
}
